// import React, { useState } from 'react';
// import { FaTimes, FaUser, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
// import { motion } from 'framer-motion';
// import { toast } from 'react-toastify';

// const CalculatorForm = ({ onSubmit, onClose, calculatorType = 'SIP' }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     location: ''
//   });
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     if (!formData.name || !formData.phone) {
//       toast.error('Please fill in your name and phone number');
//       return;
//     }

//     setIsSubmitting(true);

//     // Save lead to localStorage
//     const leads = JSON.parse(localStorage.getItem('wisdom_leads') || '[]');
//     const newLead = {
//       ...formData,
//       calculatorType,
//       timestamp: new Date().toISOString()
//     };
//     leads.unshift(newLead);
//     localStorage.setItem('wisdom_leads', JSON.stringify(leads));

//     setTimeout(() => {
//       toast.success('Details submitted successfully! Downloading your report...');
//       onSubmit(formData);
//       setIsSubmitting(false);
//     }, 500);
//   };

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
//       <motion.div
//         initial={{ opacity: 0, scale: 0.9, y: 20 }}
//         animate={{ opacity: 1, scale: 1, y: 0 }}
//         exit={{ opacity: 0, scale: 0.9, y: 20 }}
//         className="bg-white rounded-2xl max-w-md w-full p-6 relative shadow-2xl"
//       >
//         <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors">
//           <FaTimes size={20} />
//         </button>

//         <div className="text-center mb-6">
//           <div className="w-20 h-20 bg-gradient-to-r from-primary to-secondary rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
//             <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
//             </svg>
//           </div>
//           <h3 className="text-2xl font-bold text-primary">Download Your Report</h3>
//           <p className="text-gray-600 mt-1">Enter your details to get the PDF report instantly</p>
//           <p className="text-xs text-gray-500 mt-2">You'll receive the report on WhatsApp as well</p>
//         </div>

//         <form onSubmit={handleSubmit} className="space-y-4">
//           <div className="relative">
//             <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//             <input
//               type="text"
//               required
//               className="input-field pl-10"
//               placeholder="Full Name *"
//               value={formData.name}
//               onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//             />
//           </div>

//           <div className="relative">
//             <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//             <input
//               type="tel"
//               required
//               className="input-field pl-10"
//               placeholder="Phone Number *"
//               value={formData.phone}
//               onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
//             />
//           </div>

//           <div className="relative">
//             <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//             <input
//               type="email"
//               className="input-field pl-10"
//               placeholder="Email ID"
//               value={formData.email}
//               onChange={(e) => setFormData({ ...formData, email: e.target.value })}
//             />
//           </div>

//           <div className="relative">
//             <FaMapMarkerAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//             <input
//               type="text"
//               className="input-field pl-10"
//               placeholder="Location (City, State)"
//               value={formData.location}
//               onChange={(e) => setFormData({ ...formData, location: e.target.value })}
//             />
//           </div>

//           <button
//             type="submit"
//             disabled={isSubmitting}
//             className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50"
//           >
//             {isSubmitting ? 'Processing...' : '📥 Download Report Now'}
//           </button>

//           <p className="text-xs text-gray-400 text-center">
//             By downloading, you agree to receive updates from Wisdom Consultancy
//           </p>
//         </form>
//       </motion.div>
//     </div>
//   );
// };

// export default CalculatorForm;

// import React, { useState } from 'react';
// import {
//   FaTimes,
//   FaUser,
//   FaPhone,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaDownload,
//   FaWhatsapp,
// } from 'react-icons/fa';
// import { motion, AnimatePresence } from 'framer-motion';
// import { toast } from 'react-toastify';

// const CalculatorForm = ({
//   onSubmit,
//   onClose,
//   calculatorType = 'SIP',
// }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     location: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const validateForm = () => {
//     if (!formData.name.trim()) {
//       toast.error('Please enter your full name');
//       return false;
//     }

//     if (!formData.phone.trim()) {
//       toast.error('Please enter your phone number');
//       return false;
//     }

//     if (!/^[6-9]\d{9}$/.test(formData.phone)) {
//       toast.error('Please enter a valid 10-digit phone number');
//       return false;
//     }

//     if (
//       formData.email &&
//       !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
//     ) {
//       toast.error('Please enter a valid email address');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {
//       // Save Lead Data
//       const existingLeads = JSON.parse(
//         localStorage.getItem('wisdom_leads') || '[]'
//       );

//       const newLead = {
//         ...formData,
//         calculatorType,
//         createdAt: new Date().toISOString(),
//       };

//       existingLeads.unshift(newLead);

//       localStorage.setItem(
//         'wisdom_leads',
//         JSON.stringify(existingLeads)
//       );

//       toast.success(
//         'Details submitted successfully! Preparing your report...'
//       );

//       // Wait a little for better UX
//       setTimeout(() => {
//         onSubmit(formData);
//         setIsSubmitting(false);
//       }, 800);
//     } catch (error) {
//       console.error(error);
//       toast.error('Something went wrong. Please try again.');
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <AnimatePresence>
//       <motion.div
//         className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >
//         <motion.div
//           initial={{ scale: 0.9, opacity: 0, y: 20 }}
//           animate={{ scale: 1, opacity: 1, y: 0 }}
//           exit={{ scale: 0.9, opacity: 0, y: 20 }}
//           transition={{ duration: 0.3 }}
//           className="relative bg-white w-full max-w-md rounded-3xl shadow-2xl overflow-hidden"
//         >
//           {/* Top Banner */}
//           <div className="bg-gradient-to-r from-primary to-secondary p-6 text-white relative">
//             <button
//               onClick={onClose}
//               className="absolute top-4 right-4 text-white/80 hover:text-white transition"
//             >
//               <FaTimes size={20} />
//             </button>

//             <div className="flex items-center gap-4">
//               <div className="w-16 h-16 rounded-full bg-white/20 flex items-center justify-center backdrop-blur-md">
//                 <FaDownload size={28} />
//               </div>

//               <div>
//                 <h3 className="text-2xl font-bold">
//                   Download Your Report
//                 </h3>

//                 <p className="text-sm text-white/90 mt-1">
//                   Get your personalized {calculatorType} report instantly
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Form */}
//           <div className="p-6">
//             <div className="mb-5 text-center">
//               <p className="text-gray-600 text-sm">
//                 Enter your details to download the PDF report and receive it on
//                 WhatsApp.
//               </p>
//             </div>

//             <form onSubmit={handleSubmit} className="space-y-4">
//               {/* Name */}
//               <div className="relative">
//                 <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="Full Name *"
//                   value={formData.name}
//                   onChange={(e) =>
//                     handleChange('name', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-primary"
//                   required
//                 />
//               </div>

//               {/* Phone */}
//               <div className="relative">
//                 <FaPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="tel"
//                   placeholder="Phone Number *"
//                   value={formData.phone}
//                   onChange={(e) =>
//                     handleChange(
//                       'phone',
//                       e.target.value.replace(/\D/g, '')
//                     )
//                   }
//                   maxLength={10}
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-primary"
//                   required
//                 />
//               </div>

//               {/* Email */}
//               <div className="relative">
//                 <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   value={formData.email}
//                   onChange={(e) =>
//                     handleChange('email', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-primary"
//                 />
//               </div>

//               {/* Location */}
//               <div className="relative">
//                 <FaMapMarkerAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="City / State"
//                   value={formData.location}
//                   onChange={(e) =>
//                     handleChange('location', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-primary"
//                 />
//               </div>

//               {/* Benefits */}
//               <div className="bg-gray-50 rounded-xl p-4 text-sm text-gray-600 space-y-2 border">
//                 <div className="flex items-center gap-2">
//                   <FaDownload className="text-primary" />
//                   <span>Instant PDF Report Download</span>
//                 </div>

//                 <div className="flex items-center gap-2">
//                   <FaWhatsapp className="text-green-600" />
//                   <span>Receive report on WhatsApp</span>
//                 </div>

//                 <div className="flex items-center gap-2">
//                   <span className="text-primary font-bold">✓</span>
//                   <span>Free financial consultation support</span>
//                 </div>
//               </div>

//               {/* Submit Button */}
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full bg-gradient-to-r from-green-500 to-green-600 text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
//               >
//                 {isSubmitting
//                   ? 'Processing...'
//                   : '📥 Download Report Now'}
//               </button>

//               {/* Disclaimer */}
//               <p className="text-xs text-center text-gray-400 leading-relaxed">
//                 By submitting this form, you agree to receive updates and
//                 financial planning assistance from Wisdom Consultancy.
//               </p>
//             </form>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default CalculatorForm;

// import React, { useState } from 'react';
// import {
//   FaTimes,
//   FaUser,
//   FaPhone,
//   FaEnvelope,
//   FaMapMarkerAlt,
//   FaDownload,
//   FaWhatsapp,
//   FaChartLine,
// } from 'react-icons/fa';

// import { motion, AnimatePresence } from 'framer-motion';
// import { toast } from 'react-toastify';

// const CalculatorForm = ({
//   onSubmit,
//   onClose,
//   calculatorType = 'SIP',
// }) => {

//   const [formData, setFormData] = useState({
//     name: '',
//     phone: '',
//     email: '',
//     location: '',
//   });

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (field, value) => {
//     setFormData((prev) => ({
//       ...prev,
//       [field]: value,
//     }));
//   };

//   const validateForm = () => {

//     if (!formData.name.trim()) {
//       toast.error('Please enter your full name');
//       return false;
//     }

//     if (!formData.phone.trim()) {
//       toast.error('Please enter your phone number');
//       return false;
//     }

//     if (!/^[6-9]\d{9}$/.test(formData.phone)) {
//       toast.error('Please enter valid 10 digit mobile number');
//       return false;
//     }

//     if (
//       formData.email &&
//       !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
//     ) {
//       toast.error('Please enter valid email');
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setIsSubmitting(true);

//     try {

//       const existingLeads = JSON.parse(
//         localStorage.getItem('wisdom_leads') || '[]'
//       );

//       const newLead = {
//         ...formData,
//         calculatorType,
//         createdAt: new Date().toISOString(),
//       };

//       existingLeads.unshift(newLead);

//       localStorage.setItem(
//         'wisdom_leads',
//         JSON.stringify(existingLeads)
//       );

//       toast.success(
//         'Details submitted successfully!'
//       );

//       setTimeout(() => {
//         onSubmit(formData);
//         setIsSubmitting(false);
//       }, 800);

//     } catch (error) {

//       console.error(error);

//       toast.error(
//         'Something went wrong. Please try again.'
//       );

//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <AnimatePresence>

//       <motion.div
//         className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
//         initial={{ opacity: 0 }}
//         animate={{ opacity: 1 }}
//         exit={{ opacity: 0 }}
//       >

//         <motion.div
//           initial={{ scale: 0.9, opacity: 0, y: 20 }}
//           animate={{ scale: 1, opacity: 1, y: 0 }}
//           exit={{ scale: 0.9, opacity: 0, y: 20 }}
//           transition={{ duration: 0.3 }}
//           className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden"
//         >

//           {/* HEADER */}
//           <div className="bg-gradient-to-r from-[#1a3a5c] to-[#2c5f8a] p-6 text-white relative">

//             <button
//               onClick={onClose}
//               className="absolute top-4 right-4 text-white/80 hover:text-white"
//             >
//               <FaTimes size={20} />
//             </button>

//             <div className="flex items-center gap-4">

//               <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center backdrop-blur-md">
//                 <FaChartLine size={28} />
//               </div>

//               <div>
//                 <h3 className="text-2xl font-bold">
//                   Financial Report
//                 </h3>

//                 <p className="text-sm text-white/90 mt-1">
//                   Download your personalized {calculatorType} report
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* BODY */}
//           <div className="p-6">

//             <div className="text-center mb-6">
//               <h4 className="text-xl font-bold text-gray-900">
//                 Wisdom Consultancy
//               </h4>

//               <p className="text-sm text-gray-500 mt-2">
//                 Professional Financial Planning & Wealth Solutions
//               </p>
//             </div>

//             <form
//               onSubmit={handleSubmit}
//               className="space-y-4"
//             >

//               {/* NAME */}
//               <div className="relative">

//                 <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="Full Name *"
//                   value={formData.name}
//                   onChange={(e) =>
//                     handleChange('name', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                   required
//                 />
//               </div>

//               {/* PHONE */}
//               <div className="relative">

//                 <FaPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="tel"
//                   placeholder="Mobile Number *"
//                   value={formData.phone}
//                   onChange={(e) =>
//                     handleChange(
//                       'phone',
//                       e.target.value.replace(/\D/g, '')
//                     )
//                   }
//                   maxLength={10}
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                   required
//                 />
//               </div>

//               {/* EMAIL */}
//               <div className="relative">

//                 <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="email"
//                   placeholder="Email Address"
//                   value={formData.email}
//                   onChange={(e) =>
//                     handleChange('email', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                 />
//               </div>

//               {/* LOCATION */}
//               <div className="relative">

//                 <FaMapMarkerAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />

//                 <input
//                   type="text"
//                   placeholder="City / State"
//                   value={formData.location}
//                   onChange={(e) =>
//                     handleChange('location', e.target.value)
//                   }
//                   className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8]"
//                 />
//               </div>

//               {/* BENEFITS */}
//               <div className="bg-[#f8fafc] rounded-2xl p-4 border border-gray-100 space-y-3">

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <FaDownload className="text-[#2e56b8]" />
//                   Professional PDF Report
//                 </div>

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <FaWhatsapp className="text-green-600" />
//                   WhatsApp Consultation Support
//                 </div>

//                 <div className="flex items-center gap-3 text-sm text-gray-700">
//                   <span className="text-green-600 font-bold">
//                     ✓
//                   </span>

//                   Free Financial Guidance
//                 </div>
//               </div>

//               {/* BUTTON */}
//               <button
//                 type="submit"
//                 disabled={isSubmitting}
//                 className="w-full bg-gradient-to-r from-[#2e56b8] to-[#24479b] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50"
//               >
//                 {isSubmitting
//                   ? 'Processing...'
//                   : '📥 Download Financial Report'}
//               </button>

//               {/* DISCLAIMER */}
//               <p className="text-xs text-center text-gray-400 leading-relaxed">
//                 Mutual Fund investments are subject to market risks.
//                 Read all scheme related documents carefully before investing.
//               </p>

//             </form>
//           </div>
//         </motion.div>
//       </motion.div>
//     </AnimatePresence>
//   );
// };

// export default CalculatorForm;

import React, { useState } from 'react';
import {
  FaTimes,
  FaUser,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaDownload,
  FaWhatsapp,
  FaChartLine,
} from 'react-icons/fa';

import { motion, AnimatePresence } from 'framer-motion';
import { toast } from 'react-toastify';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

const CalculatorForm = ({
  onSubmit,
  onClose,
  calculatorType = 'SIP',
  calculationData = null,
  userInputs = {},
}) => {

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    location: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error('Please enter your full name');
      return false;
    }

    if (!formData.phone.trim()) {
      toast.error('Please enter your phone number');
      return false;
    }

    if (!/^[6-9]\d{9}$/.test(formData.phone)) {
      toast.error('Please enter valid 10 digit mobile number');
      return false;
    }

    if (
      formData.email &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)
    ) {
      toast.error('Please enter valid email');
      return false;
    }

    return true;
  };

  const formatCurrency = (amount) => {
    if (!amount && amount !== 0) return '₹0';
    return `₹${Number(amount || 0).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;
  };

  const formatLargeNumber = (amount) => {
    if (!amount && amount !== 0) return '₹0';
    if (amount >= 10000000) {
      return `₹${(amount / 10000000).toFixed(2)} Cr`;
    }
    if (amount >= 100000) {
      return `₹${(amount / 100000).toFixed(2)} L`;
    }
    return formatCurrency(amount);
  };

  const generatePDF = () => {
    const doc = new jsPDF('p', 'mm', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    let yPos = 20;

    // Colors
    const primaryColor = [46, 86, 184]; // #2e56b8
    const secondaryColor = [103, 191, 115]; // #67bf73
    const textColor = [51, 51, 51];
    const lightBg = [245, 247, 250];

    // Helper function to add text with word wrap
    const addWrappedText = (text, x, y, maxWidth, fontSize = 10, isBold = false) => {
      doc.setFontSize(fontSize);
      doc.setFont('helvetica', isBold ? 'bold' : 'normal');
      const lines = doc.splitTextToSize(text, maxWidth);
      doc.text(lines, x, y);
      return y + (lines.length * (fontSize * 0.3528)) + 2;
    };

    // ============ HEADER SECTION ============
    // Top border line
    doc.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.setLineWidth(1);
    doc.line(15, yPos, pageWidth - 15, yPos);
    yPos += 10;

    // Company Name
    doc.setFontSize(24);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.text('Wisdom Consultancy', pageWidth / 2, yPos, { align: 'center' });
    yPos += 10;

    // Address
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('E-44, Vasant Vihar Society, GIDC-Vadsar Road, Vadodara-390010', pageWidth / 2, yPos, { align: 'center' });
    yPos += 5;
    doc.text('📞 9726344477 | ✉ wisdom2secure@gmail.com', pageWidth / 2, yPos, { align: 'center' });
    yPos += 12;

    // Bottom border line
    doc.setDrawColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.line(15, yPos, pageWidth - 15, yPos);
    yPos += 10;

    // ============ REPORT TITLE ============
    doc.setFontSize(18);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.text(`${calculatorType} Report`, pageWidth / 2, yPos, { align: 'center' });
    yPos += 8;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(120, 120, 120);
    const dateStr = new Date().toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
    doc.text(`Generated on: ${dateStr}`, pageWidth / 2, yPos, { align: 'center' });
    yPos += 15;

    // ============ CLIENT INFORMATION SECTION ============
    // Section background
    doc.setFillColor(lightBg[0], lightBg[1], lightBg[2]);
    doc.rect(15, yPos - 5, pageWidth - 30, 45, 'F');
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.text('👤 Client Information', 20, yPos);
    yPos += 8;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(textColor[0], textColor[1], textColor[2]);
    
    // Client details in two columns
    const col1X = 20;
    const col2X = pageWidth / 2 + 10;
    
    doc.text(`Name: ${formData.name}`, col1X, yPos);
    doc.text(`Mobile: ${formData.phone}`, col2X, yPos);
    yPos += 7;
    
    doc.text(`Email: ${formData.email || 'Not provided'}`, col1X, yPos);
    doc.text(`Location: ${formData.location || 'Not provided'}`, col2X, yPos);
    yPos += 15;

    // ============ INVESTMENT SUMMARY SECTION ============
    doc.setFillColor(lightBg[0], lightBg[1], lightBg[2]);
    doc.rect(15, yPos - 5, pageWidth - 30, 50, 'F');
    
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.text('📊 Investment Summary', 20, yPos);
    yPos += 8;

    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    
    const summaryData = [];
    
    // Add user inputs based on calculator type
    if (userInputs.monthlyInvestment !== undefined) {
      summaryData.push(['Initial Monthly SIP', formatCurrency(userInputs.monthlyInvestment)]);
    }
    if (userInputs.monthlySIP !== undefined) {
      summaryData.push(['Monthly SIP Amount', formatCurrency(userInputs.monthlySIP)]);
    }
    if (userInputs.lumpsumAmount !== undefined && userInputs.lumpsumAmount > 0) {
      summaryData.push(['Lumpsum Investment', formatCurrency(userInputs.lumpsumAmount)]);
    }
    if (userInputs.stepUpRate !== undefined) {
      summaryData.push(['Annual Step-Up Rate', `${userInputs.stepUpRate}%`]);
    }
    if (userInputs.yearlyStepUp !== undefined && userInputs.yearlyStepUp > 0) {
      summaryData.push(['Yearly Step-Up Amount', formatCurrency(userInputs.yearlyStepUp)]);
    }
    if (userInputs.expectedReturn !== undefined) {
      summaryData.push(['Expected Return', `${userInputs.expectedReturn}% p.a.`]);
    }
    if (userInputs.expectedReturnSIP !== undefined) {
      summaryData.push(['Expected Return (SIP)', `${userInputs.expectedReturnSIP}% p.a.`]);
    }
    if (userInputs.inflationRate !== undefined) {
      summaryData.push(['Inflation Rate', `${userInputs.inflationRate}% p.a.`]);
    }
    if (userInputs.timePeriod !== undefined) {
      summaryData.push(['Investment Duration', `${userInputs.timePeriod} Years`]);
    }
    if (userInputs.sipTenure !== undefined) {
      summaryData.push(['SIP Tenure', `${userInputs.sipTenure} Years`]);
    }
    if (userInputs.currentAge !== undefined) {
      summaryData.push(['Current Age', `${userInputs.currentAge} Years`]);
    }

    // Draw summary table
    doc.autoTable({
      startY: yPos - 5,
      head: [['Parameter', 'Value']],
      body: summaryData,
      theme: 'striped',
      headStyles: { fillColor: primaryColor, textColor: [255, 255, 255], fontSize: 10 },
      bodyStyles: { fontSize: 9, textColor: textColor },
      columnStyles: { 0: { cellWidth: 100 }, 1: { cellWidth: 60 } },
      margin: { left: 20, right: 20 },
    });
    
    yPos = doc.lastAutoTable.finalY + 10;

    // ============ MAIN RESULT CARD ============
    const mainCorpus = calculationData?.futureValue || calculationData?.sipFV || calculationData?.totalCorpus || 0;
    
    // Draw colored box for main result
    doc.setFillColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.roundedRect(30, yPos, pageWidth - 60, 35, 5, 5, 'F');
    
    doc.setFontSize(11);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(255, 255, 255);
    doc.text(calculatorType === 'Step-Up SIP' ? 'Projected Future Value' : 'Estimated Wealth Corpus', pageWidth / 2, yPos + 8, { align: 'center' });
    
    doc.setFontSize(22);
    doc.setFont('helvetica', 'bold');
    doc.text(formatLargeNumber(mainCorpus), pageWidth / 2, yPos + 26, { align: 'center' });
    yPos += 40;

    // ============ STATS GRID ============
    const totalInvestment = calculationData?.totalInvestment || calculationData?.totalInvestedSIP || calculationData?.investedAmount || 0;
    const totalReturns = calculationData?.totalReturns || calculationData?.estimatedReturns || 0;
    
    // Box 1 - Total Investment
    doc.setFillColor(lightBg[0], lightBg[1], lightBg[2]);
    doc.roundedRect(20, yPos, (pageWidth - 50) / 2, 30, 5, 5, 'F');
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('Total Investment', 20 + ((pageWidth - 50) / 2) / 2, yPos + 10, { align: 'center' });
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(primaryColor[0], primaryColor[1], primaryColor[2]);
    doc.text(formatLargeNumber(totalInvestment), 20 + ((pageWidth - 50) / 2) / 2, yPos + 23, { align: 'center' });
    
    // Box 2 - Wealth Generated
    doc.setFillColor(lightBg[0], lightBg[1], lightBg[2]);
    doc.roundedRect(pageWidth / 2 + 5, yPos, (pageWidth - 50) / 2, 30, 5, 5, 'F');
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    doc.text('Wealth Generated', (pageWidth / 2 + 5) + ((pageWidth - 50) / 2) / 2, yPos + 10, { align: 'center' });
    doc.setFontSize(14);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(secondaryColor[0], secondaryColor[1], secondaryColor[2]);
    doc.text(formatLargeNumber(totalReturns), (pageWidth / 2 + 5) + ((pageWidth - 50) / 2) / 2, yPos + 23, { align: 'center' });
    yPos += 38;

    // ============ RESULT TABLE ============
    const resultData = [
      ['Total Invested Amount', formatLargeNumber(totalInvestment)],
      ['Estimated Returns', formatLargeNumber(totalReturns)],
      ['Total Corpus / Future Value', formatLargeNumber(mainCorpus)],
    ];
    
    if (calculationData?.wealthMultiplier) {
      resultData.push(['Wealth Multiplier', `${calculationData.wealthMultiplier.toFixed(2)}x`]);
    }
    
    if (calculationData?.inflationAdjustedValue) {
      resultData.push(['Inflation Adjusted Value', formatLargeNumber(calculationData.inflationAdjustedValue)]);
    }
    
    if (calculationData?.regularSIPFutureValue) {
      resultData.push(['Regular SIP Value', formatLargeNumber(calculationData.regularSIPFutureValue)]);
      resultData.push(['Extra Gain from Step-Up', formatLargeNumber(calculationData.extraGain)]);
      resultData.push(['Additional Return', `+${calculationData.gainPercentage}%`]);
    }
    
    doc.autoTable({
      startY: yPos - 5,
      head: [['Result Parameter', 'Value']],
      body: resultData,
      theme: 'striped',
      headStyles: { fillColor: secondaryColor, textColor: [255, 255, 255], fontSize: 10 },
      bodyStyles: { fontSize: 9, textColor: textColor },
      columnStyles: { 0: { cellWidth: 100 }, 1: { cellWidth: 60 } },
      margin: { left: 20, right: 20 },
    });
    
    yPos = doc.lastAutoTable.finalY + 10;

    // ============ WITHDRAWAL PHASE (if applicable) ============
    if (calculationData?.withdrawalStartAge || userInputs.monthlyWithdrawal) {
      // Check if we need a new page
      if (yPos > 220) {
        doc.addPage();
        yPos = 20;
      }
      
      doc.setFillColor(lightBg[0], lightBg[1], lightBg[2]);
      doc.rect(15, yPos - 5, pageWidth - 30, 10, 'F');
      doc.setFontSize(12);
      doc.setFont('helvetica', 'bold');
      doc.setTextColor(255, 140, 0);
      doc.text('🔄 Withdrawal Phase Summary', 20, yPos);
      yPos += 8;
      
      const withdrawalData = [];
      
      if (calculationData?.withdrawalStartAge) {
        withdrawalData.push(['Withdrawal Start Age', `${calculationData.withdrawalStartAge} Years`]);
      }
      if (userInputs.monthlyWithdrawal) {
        withdrawalData.push(['Monthly Withdrawal Amount', formatCurrency(userInputs.monthlyWithdrawal)]);
      }
      if (calculationData?.withdrawalYears) {
        withdrawalData.push(['Withdrawal Duration', `${calculationData.withdrawalYears} Years`]);
      }
      if (calculationData?.totalWithdrawn) {
        withdrawalData.push(['Total Withdrawn', formatLargeNumber(calculationData.totalWithdrawn)]);
      }
      if (calculationData?.finalCorpus) {
        withdrawalData.push(['Remaining Corpus', formatLargeNumber(calculationData.finalCorpus)]);
      }
      if (calculationData?.withdrawalStartAge && calculationData?.withdrawalEndAge) {
        withdrawalData.push(['Age Range', `${calculationData.withdrawalStartAge} - ${calculationData.withdrawalEndAge} Years`]);
      }
      if (userInputs.increasePercentage) {
        withdrawalData.push(['Annual Increase', `${userInputs.increasePercentage}%`]);
      }
      if (calculationData?.yearsBetween && calculationData.yearsBetween > 0) {
        withdrawalData.push(['Post SIP Growth Period', `${calculationData.yearsBetween} Years`]);
      }
      if (calculationData?.corpusAtWithdrawalStart && calculationData.corpusAtWithdrawalStart !== mainCorpus) {
        withdrawalData.push(['Corpus at Withdrawal Start', formatLargeNumber(calculationData.corpusAtWithdrawalStart)]);
      }
      
      doc.autoTable({
        startY: yPos - 5,
        head: [['Parameter', 'Value']],
        body: withdrawalData,
        theme: 'striped',
        headStyles: { fillColor: [255, 140, 0], textColor: [255, 255, 255], fontSize: 10 },
        bodyStyles: { fontSize: 9, textColor: textColor },
        columnStyles: { 0: { cellWidth: 100 }, 1: { cellWidth: 60 } },
        margin: { left: 20, right: 20 },
      });
      
      yPos = doc.lastAutoTable.finalY + 10;
    }

    // ============ DISCLAIMER ============
    // Check if we need a new page for disclaimer
    if (yPos > 240) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setFillColor(254, 243, 226);
    doc.rect(15, yPos, pageWidth - 30, 35, 'F');
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(133, 100, 4);
    doc.text('⚠️ Disclaimer', 20, yPos + 5);
    
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(100, 100, 100);
    const disclaimerText = 'Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing. Past performance is not indicative of future returns. The calculations provided are estimates based on the inputs provided and actual returns may vary. Please consult with a certified financial advisor before making any investment decisions.';
    yPos = addWrappedText(disclaimerText, 20, yPos + 10, pageWidth - 40, 8, false);
    yPos += 5;

    // ============ FOOTER ============
    if (yPos > 270) {
      doc.addPage();
      yPos = 20;
    }
    
    doc.setDrawColor(200, 200, 200);
    doc.line(15, yPos, pageWidth - 15, yPos);
    yPos += 5;
    
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(150, 150, 150);
    doc.text('Wisdom Consultancy - Your Trusted Financial Partner | www.wisdomconsultancy.com', pageWidth / 2, yPos, { align: 'center' });
    yPos += 5;
    doc.text('This is a system generated report and does not require signature.', pageWidth / 2, yPos, { align: 'center' });
    yPos += 4;
    doc.text('ARN No: ARN-XXXXX | Valid for planning purposes only', pageWidth / 2, yPos, { align: 'center' });

    // Save the PDF
    doc.save(`Wisdom_${calculatorType.replace(/\s/g, '_')}_Report_${formData.name.replace(/\s/g, '_')}.pdf`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setIsSubmitting(true);

    try {
      // Save lead to localStorage
      const existingLeads = JSON.parse(
        localStorage.getItem('wisdom_leads') || '[]'
      );

      const newLead = {
        ...formData,
        calculatorType,
        calculationData: calculationData ? JSON.stringify(calculationData) : null,
        userInputs: userInputs ? JSON.stringify(userInputs) : null,
        createdAt: new Date().toISOString(),
      };

      existingLeads.unshift(newLead);
      localStorage.setItem('wisdom_leads', JSON.stringify(existingLeads));

      toast.success('Details submitted successfully! Generating PDF...');

      // Generate PDF
      generatePDF();

      toast.success('PDF Report downloaded successfully!');

      setTimeout(() => {
        onSubmit(formData);
        setIsSubmitting(false);
      }, 500);

    } catch (error) {
      console.error(error);
      toast.error('Something went wrong. Please try again.');
      setIsSubmitting(false);
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          initial={{ scale: 0.9, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          exit={{ scale: 0.9, opacity: 0, y: 20 }}
          transition={{ duration: 0.3 }}
          className="relative bg-white w-full max-w-md rounded-[32px] shadow-2xl overflow-hidden"
          onClick={(e) => e.stopPropagation()}
        >
          {/* HEADER */}
          <div className="bg-gradient-to-r from-[#1a3a5c] to-[#2c5f8a] p-6 text-white relative">
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-white/80 hover:text-white transition-colors"
            >
              <FaTimes size={20} />
            </button>

            <div className="flex items-center gap-4">
              <div className="w-16 h-16 rounded-2xl bg-white/20 flex items-center justify-center backdrop-blur-md">
                <FaChartLine size={28} />
              </div>
              <div>
                <h3 className="text-2xl font-bold">
                  Financial Report
                </h3>
                <p className="text-sm text-white/90 mt-1">
                  Download your personalized {calculatorType} report
                </p>
              </div>
            </div>
          </div>

          {/* BODY */}
          <div className="p-6">
            <div className="text-center mb-6">
              <h4 className="text-xl font-bold text-gray-900">
                Wisdom Consultancy
              </h4>
              <p className="text-sm text-gray-500 mt-2">
                Professional Financial Planning & Wealth Solutions
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              {/* NAME */}
              <div className="relative">
                <FaUser className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Full Name *"
                  value={formData.name}
                  onChange={(e) => handleChange('name', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                  required
                />
              </div>

              {/* PHONE */}
              <div className="relative">
                <FaPhone className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="tel"
                  placeholder="Mobile Number *"
                  value={formData.phone}
                  onChange={(e) => handleChange('phone', e.target.value.replace(/\D/g, ''))}
                  maxLength={10}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                  required
                />
              </div>

              {/* EMAIL */}
              <div className="relative">
                <FaEnvelope className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="email"
                  placeholder="Email Address"
                  value={formData.email}
                  onChange={(e) => handleChange('email', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                />
              </div>

              {/* LOCATION */}
              <div className="relative">
                <FaMapMarkerAlt className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="City / State"
                  value={formData.location}
                  onChange={(e) => handleChange('location', e.target.value)}
                  className="w-full border border-gray-200 rounded-xl py-3 pl-12 pr-4 outline-none focus:ring-2 focus:ring-[#2e56b8] transition-all"
                />
              </div>

              {/* BENEFITS */}
              <div className="bg-[#f8fafc] rounded-2xl p-4 border border-gray-100 space-y-3">
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <FaDownload className="text-[#2e56b8]" />
                  Professional PDF Report
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <FaWhatsapp className="text-green-600" />
                  WhatsApp Consultation Support
                </div>
                <div className="flex items-center gap-3 text-sm text-gray-700">
                  <span className="text-green-600 font-bold">✓</span>
                  Free Financial Guidance
                </div>
              </div>

              {/* BUTTON */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-gradient-to-r from-[#2e56b8] to-[#24479b] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {isSubmitting ? '⏳ Generating Report...' : '📥 Download Financial Report'}
              </button>

              {/* DISCLAIMER */}
              <p className="text-xs text-center text-gray-400 leading-relaxed">
                By submitting this form, you agree to receive communication from Wisdom Consultancy.
                Mutual Fund investments are subject to market risks. Read all scheme related documents carefully before investing.
              </p>
            </form>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default CalculatorForm;

